import { Component, Host, h, Listen, State, Element } from '@stencil/core';
import { getPlatforms } from '@baloise/ds-core';
import Masonry from 'masonry-layout';

@Component({
  tag: 'bam-blog-teaser',
  styleUrl: 'bam-blog-teaser.scss',
  shadow: false,
})
export class BamBlogTeaser {
  @State() viewport: string;
  masonaryGrid: HTMLElement;
  private msnry;

  @Element() el: HTMLElement;
  @State() refreshItems: boolean = false;

  @Listen('loadedMore', { target: 'window' })
  loadedMoreHandler(event: CustomEvent) {
    if (event.detail) {
      if ((this.viewport == 'tablet' || this.viewport == 'desktop') && this.msnry) {
        setTimeout(() => {
          let counter = 0;
          let bamBlogTeaserItems = Array.from(this.el.querySelectorAll('bam-blog-teaser-item')) as HTMLBamBlogTeaserItemElement[];
          const updateItems = () => {
            counter = counter + 1;
            if (counter === bamBlogTeaserItems.length) {
              if (this.masonaryGrid) {
                this.initMasonaryGrid();
                this.refreshItems = true;
              }
            }
          };

          !!bamBlogTeaserItems &&
            bamBlogTeaserItems.length > 0 &&
            bamBlogTeaserItems.forEach(item => {
              item.componentOnReady().then(() => {
                let card = item.querySelector('bal-card') as HTMLBalCardElement;
                let image = item.querySelector('bam-image') as HTMLBamImageElement;

                card.componentOnReady().then(() => {
                  if (!!image) {
                    image.componentOnReady().then(() => {
                      updateItems();
                    });
                  } else {
                    updateItems();
                  }
                });
              });
            });
        }, 100);
        this.refreshItems = false;
      }
    }
  }

  @Listen('resize', { target: 'window' })
  onResizeWindow() {
    if (this.masonaryGrid) {
      const currentViewport = getPlatforms()[0];
      if (currentViewport !== this.viewport) {
        this.viewport = currentViewport;
        this.msnry.destroy();
        this.initMasonaryGrid();
      }
    }
  }

  initMasonaryGrid() {
    if (this.viewport == 'tablet' || this.viewport == 'desktop') {
      this.msnry = new Masonry(this.masonaryGrid, {
        // options
        itemSelector: '.grid-item',
        percentPosition: true,
        horizontalOrder: this.viewport == 'desktop',
        containerStyle: null,
        transitionDuration: 0,
      });
    }
  }

  componentWillLoad() {
    this.viewport = getPlatforms()[0];
    this.masonaryGrid = this.el.querySelector('.masonary-grid');
    if (this.masonaryGrid) {
      this.initMasonaryGrid();
    }
  }

  componentWillUpdate() {
    this.msnry.reloadItems();
    this.msnry.layout();
  }

  componentDidLoad() {
    if (!this.msnry) {
      return;
    }
    setTimeout(() => {
      this.msnry.layout();
    }, 100);
  }

  render() {
    return <Host></Host>;
  }
}
